import { render, staticRenderFns } from "./RacunZaUplatuCreate.vue?vue&type=template&id=62962c3c&scoped=true&"
import script from "./RacunZaUplatuCreate.vue?vue&type=script&lang=js&"
export * from "./RacunZaUplatuCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62962c3c",
  null
  
)

export default component.exports